import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { KARITO_PHOTO } from '../data/content';
export function About() {
  return <section className="border-b border-line bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-18" data-mp="2tt274crvw5gl">
      <SectionHeading eyebrow="Qui est à l’origine de ce système ?" title="À propos de la Dre Karito" data-id="element-19" data-mp="2tv6gha8jxwo9" />

      <div className="mx-auto mt-10 grid w-full max-w-4xl grid-cols-1 gap-6 lg:grid-cols-[300px_1fr] lg:items-start" data-id="element-20" data-mp="2ypsm0wrycv0f">
        <figure className="mx-auto w-full max-w-[300px]" data-id="element-21" data-mp="38q30sltmyahp">
          <img src={KARITO_PHOTO} alt="Portrait de la Dre Karito, créatrice de Route Maladie Rénale™" className="w-full rounded-2xl border border-line object-cover" width={800} height={1000} loading="lazy" data-id="element-22" data-mp="38oi5uv3espjb" />
          <figcaption className="mt-3 text-center lg:text-left" data-id="element-23" data-mp="3mjarmb9w71yc">
            <span className="block font-display text-lg font-extrabold text-white" data-id="element-24" data-mp="3rg16wwdvhtip">Dre Karito</span>
            <span className="block text-[13px] font-semibold uppercase tracking-wide text-lime" data-id="element-25" data-mp="2lrh7bqrfk772">
              Créatrice de Route Maladie Rénale™
            </span>
          </figcaption>
        </figure>

        <div className="space-y-4 text-[15px] leading-relaxed text-slate-300" data-id="element-26" data-mp="2cpr9a231ma0b">
          <p data-id="element-27" data-mp="27rzf11exebsy">
            Pendant des années, j’ai vu des médecins brillants confrontés au même problème : ils ne
            manquaient pas de connaissances. Ils manquaient d’une manière rapide de transformer ces
            connaissances en décisions cliniques.
          </p>
          <p data-id="element-28" data-mp="30ihii3jkaf6w">
            Les recommandations répondent à presque toutes les questions. Mais elles répondent
            rarement à la plus importante :
          </p>
          <p className="border-l-2 border-lime pl-4 font-semibold italic text-white" data-id="element-29" data-mp="2qpsgs0dtcfor">
            « Que dois-je faire avec le patient que j’ai devant moi, ici et maintenant ? »
          </p>
          <p data-id="element-30" data-mp="3je7m1v757jmw">
            C’est pour cette raison que j’ai créé Route Maladie Rénale™. Non pas comme un nouveau
            manuel à étudier, mais comme un système pratique qui transforme des recommandations
            complexes en décisions claires, rapides et applicables dès la première consultation.
          </p>
          <p className="font-semibold text-white" data-id="element-31" data-mp="3tio0ql8vyup4">
            Mon objectif est que vous n’ayez plus jamais à dire : « Laissez-moi vérifier et je vous
            répondrai ensuite. »
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-32" data-mp="3ojtgdev9sy2w">
        <CTAButton label="Je veux la route de la Dre Karito" caption="Système clinique complet • Paiement unique de 19 €" data-id="element-33" data-mp="3okmghwzq4pc2" />
      </div>
    </section>;
}